
















import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import { Component } from 'vue-property-decorator'
import { ElDrawer } from 'element-ui/types/drawer'

const BaseVue = Vue.extend({
  props: {
    showSections: Boolean
  },
  computed: {
    ...mapState(['sections'])
  },
  methods: {
    ...mapActions(['setCurrentPageIndexFromPage'])
  }
})

@Component
export default class Sections extends BaseVue {
  onChangeVisibility ($event: any) {
    this.$emit('update:showSections', $event)
  }

  goToPage (page: number) {
    this.onChangeVisibility(false)

    setTimeout(() => {
      this.setCurrentPageIndexFromPage(page)
    }, 200)
  }
}
